import ToggleWeightCost from "@/components/toggleWeightCost/toggleWeightCost.vue";
import { createNamespacedHelpers } from "vuex";
import { REQUEST_STATE } from "@/enums";
import vClickOutside from "v-click-outside";
import CheckBox from "@/components/checkBox/checkBox.vue";
import { serviceTimeRangeToString } from "@/utils";

const { mapGetters: userGetters } = createNamespacedHelpers("user"),
	{ mapGetters: filtersGetters } = createNamespacedHelpers("filters"),
	{ mapGetters: brandingGetters } = createNamespacedHelpers("branding");

export default {
	props: {
		data: { type: Object },

		state: {
			type: String,
			validator(requestState) {
				return Object.keys(REQUEST_STATE).includes(requestState);
			},
		},
	},
	components: {
		ToggleWeightCost,
		CheckBox,
	},

	directives: { clickOutside: vClickOutside.directive },

	data() {
		return {
			showServiceTimeDropdown: false,
			selectedST: null,

			isCostToggleActive: false,
			REQUEST_STATE,
			tooltipContent: [
				{
					text: "tooltips_content.service_time.title",
					type: "headline",
				},
				{
					text: "service_times.tip",
					type: "text",
				},
			],
		};
	},

	computed: {
		...userGetters(["activeOutlet", "weightUnit", "weightFactor", "serviceTimeSets"]),

		...brandingGetters(["sourceWasteColors"]),

		...filtersGetters(["activePeriod", "activeWasteType"]),

		STSetIDs() {
			if (this.state !== REQUEST_STATE.SUCCESS) return;
			return Object.keys(this.data)
				.map((k) => parseInt(k))
				.sort()
				.reverse();
		},

		longestBar,
	},

	methods: {
		toggleDropdown,
		onSelectST,
		getSTName,
		getSTTotal,
		getSubBar,
		serviceTimeRangeToString,
	},

	watch: {
		data(newData, oldData) {
			if (newData !== oldData) {
				if (this.STSetIDs) {
					// there is always at least one service time set defined
					this.selectedST = [...this.STSetIDs];
				}
			}
		},
	},
};

function longestBar() {
	let max = 0;

	if (!this.selectedST) return max;

	this.selectedST.forEach((id) => {
		this.serviceTimeSets[id].st_labels.forEach((label) => {
			const total = this.getSTTotal(id, label);

			if (total > max) max = total;
		});
	});

	return max;
}

function getSubBar(id, stLabel, sourceName) {
	const source = this.data[id][stLabel][sourceName];
	return this.isCostToggleActive ? source.cost : source.weight;
}

function onSelectST(stsID) {
	if (this.selectedST.includes(stsID)) {
		if (this.selectedST.length !== 1) this.selectedST = this.selectedST.filter((sts) => sts !== stsID);
	} else {
		this.selectedST.push(stsID);
		this.selectedST = this.selectedST.sort().reverse();
	}
}

function getSTName(stsID) {
	return this.$utils.capitalizeFirstLetter(this.serviceTimeSets[stsID].data.name);
}

function toggleDropdown() {
	this.showServiceTimeDropdown = !this.showServiceTimeDropdown;
}

function getSTTotal(stsID, stLabel) {
	const stData = this.data[stsID][stLabel];
	return Object.values(stData).reduce((sum, v) => sum + (this.isCostToggleActive ? v.cost : v.weight), 0);
}
